// extracted by mini-css-extract-plugin
export default {"addProjectBtn":"ProjectSelect_addProjectBtn__NMFa-"};